import { __ } from '@wordpress/i18n';
import clsx from 'clsx';
import PanelSettings from './advance/inspector-control';
import Advance from './advance';
import { VayuBlocksUniqueId } from '@vayu-blocks/global';
import { InnerBlocks} from '@wordpress/block-editor';
import {  useDispatch } from '@wordpress/data';
import {CustomBlockControls} from './block-control';
import { Button } from '@wordpress/components';
import { createBlock } from '@wordpress/blocks';
import { useSelect } from '@wordpress/data';

const edit = (props) => {
	const { attributes, setAttributes, clientId, isSelected } = props;
	
	VayuBlocksUniqueId({ setAttributes, clientId });

	const faq_template = React.useMemo(() => [
        ['vayu-blocks/faq-child', {}],
		['vayu-blocks/faq-child', {}],
		['vayu-blocks/faq-child', {}],
    ], []);

	const containerClass = clsx(
		'vb-faq-wrapper',
		attributes.showtype === 'accordation' ? 'vb-type-accordation' : 'vb-type-grid'
	);

	const { updateBlockAttributes } = useDispatch('core/block-editor');

	const onChildToggle = (childId) => {
		if (attributes.activeChildId === childId) {
			updateBlockAttributes(clientId, { activeChildId: '' }); // Close if same clicked
		} else {
			updateBlockAttributes(clientId, { activeChildId: childId }); // Open new
		}
	};

	const { insertBlock } = useDispatch('core/block-editor');

	// Get innerBlocks clientId (for InnerBlocks container)
	const innerBlockClientId = useSelect((select) => {
		const { getBlockOrder } = select('core/block-editor');
		return getBlockOrder(clientId)[0]; // First position for InnerBlocks inside parent
	}, [clientId]);

	const addFAQItem = () => {
		const newBlock = createBlock('vayu-blocks/faq-child', {});
		insertBlock(newBlock, undefined, clientId); // Insert directly into parent InnerBlocks
	};

	return (
		<>

			{isSelected && (
				<CustomBlockControls 
					setAttributes={setAttributes}
					attributes={attributes}
					clientId={clientId}
				/>
			)}

			<PanelSettings attributes={attributes} setAttributes={setAttributes} isSelected={isSelected} clientId={clientId} />
			<Advance attributes={attributes} clientId={clientId}>

				<div className={containerClass}>
					<InnerBlocks 
						template={faq_template} 
						allowedBlocks={['vayu-blocks/faq-child']} 
						renderAppender={false}
					/>
				</div>

				<button
					variant="primary"
					icon="plus"
					isSmall
					className="vb-faq-add-button"
					onClick={addFAQItem}
				>
					{__('Add FAQ Item', 'vayu-blocks')}
				</button>

			</Advance>
		</>
	);
};

export default edit;